import { useCallback } from "react"
import { useDispatch } from "react-redux"
import { Creators as DataCreators } from "model/data"
import type { SigmaSolution } from "connected-components/solutions/types"
import SigmaSolutionCard from "connected-components/solutions/components/sigma-solution-card"

interface SigmaSolutionsPreviewProps {
  sigmaSolutions: SigmaSolution[]
  accountAlias: string
  isSuperuser: boolean
}

function SigmaSolutionsPreview({ sigmaSolutions, accountAlias, isSuperuser }: SigmaSolutionsPreviewProps) {
  const dispatch = useDispatch()
  const solutionsUrl = `/api/${accountAlias}/solutions/sigma`

  const refreshSigmaSolutions = useCallback(() => {
    dispatch(DataCreators.load("sigmaSolutions", solutionsUrl, solutionsUrl))
  }, [dispatch, solutionsUrl])

  return (
    <>
      <div className="sigma-solutions-list">
        {sigmaSolutions.map(solution => (
          <SigmaSolutionCard
            key={solution.id}
            solution={solution}
            isSuperuser={isSuperuser}
            accountAlias={accountAlias}
            onRefresh={refreshSigmaSolutions}
          />
        ))}
      </div>
    </>
  )
}

export default SigmaSolutionsPreview
